/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/templates/article.js":
/*!******************************************!*\
  !*** ./src/scripts/templates/article.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ \"jquery\");\n/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var slick_carousel_slick_slick_min_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! slick-carousel/slick/slick.min.js */ \"./node_modules/slick-carousel/slick/slick.min.js\");\n/* harmony import */ var slick_carousel_slick_slick_min_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_min_js__WEBPACK_IMPORTED_MODULE_1__);\n/* harmony import */ var _styles_templates_article_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/styles/templates/article.scss */ \"./src/styles/templates/article.scss\");\n\r\n\r\n \r\n\r\ncommentsCarousel();\r\narticleLoadFull();\r\nsidebarSticky();\r\n\r\nrelatedPostsCarousel();\r\njquery__WEBPACK_IMPORTED_MODULE_0___default()( window ).resize(function() {\r\n  relatedPostsCarousel();\r\n});\r\n\r\nfunction commentsCarousel() {\r\n  var commentsCarousel = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-comments-carousel');\r\n  commentsCarousel.slick({\r\n    infinite: false,\r\n    speed: 500,\r\n    slidesToShow: 3,\r\n    slidesToScroll: 1,\r\n    touchThreshold: 1,\r\n    arrows: true,\r\n    appendArrows: '.comments__actions-arrows',\r\n    responsive: [\r\n      {\r\n        breakpoint: 992,\r\n        settings: {\r\n          slidesToShow: 2,\r\n          centerMode: false\r\n        }\r\n      },\r\n      {\r\n        breakpoint: 600,\r\n        settings: {\r\n          slidesToShow: 1,\r\n          centerMode: false\r\n        }\r\n      }\r\n    ]\r\n  });\r\n}\r\n\r\njquery__WEBPACK_IMPORTED_MODULE_0___default()(window).resize(function(){\r\n  articleLoadFull();\r\n  sidebarSticky();\r\n});\r\n\r\n\r\n// expand article when load full article button is clicked\r\nfunction articleLoadFull() {\r\n  let articleContent = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-article__content-main');\r\n  let articleContentHeight = articleContent.height();\r\n  let articleSidebar = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-article__sidebar');\r\n  let articleSidebarHeight = articleSidebar.height();\r\n  let loadFullArticleBtn = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-article__load-full-btn');\r\n  let prevArticleBtn = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-article__previous-btn');\r\n\r\n  if (articleContentHeight > articleSidebarHeight && articleContentHeight > 700 && !articleContent.hasClass('is-expanded')) {\r\n    articleContent.addClass('is-collapsed');\r\n    loadFullArticleBtn.removeClass('hide');\r\n    articleContent.css('height', 700);\r\n  } else {\r\n    loadFullArticleBtn.addClass('hide');\r\n  }\r\n\r\n  loadFullArticleBtn.on('click touch', function (event) {\r\n    event.preventDefault();\r\n    expandArticle();\r\n  });\r\n\r\n  prevArticleBtn.on('click touch', function (event) {\r\n    event.preventDefault();\r\n    collapseArticle();\r\n  });\r\n\r\n  function expandArticle() {\r\n    articleContent.removeClass('is-collapsed').addClass('is-expanded');\r\n    articleContent.css('height', 'auto');\r\n    loadFullArticleBtn.addClass('hide');\r\n    prevArticleBtn.removeClass('hide');\r\n  }\r\n\r\n  function collapseArticle() {\r\n    articleContent.removeClass('is-expanded').addClass('is-collapsed');\r\n    articleContent.css('height', 700);\r\n    prevArticleBtn.addClass('hide');\r\n    loadFullArticleBtn.removeClass('hide');\r\n  }\r\n\r\n  setTimeout(function () {\r\n    if (!loadFullArticleBtn.hasClass('hide')) {\r\n      loadFullArticleBtn.trigger('click');\r\n    }\r\n  }, 5000);\r\n}\r\n\r\nfunction sidebarSticky() {\r\n  var sidebarWrapper = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.article__sidebar-wrapper');\r\n  if (sidebarWrapper.height() < jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).height() ) {\r\n    sidebarWrapper.addClass('is-sticky');\r\n  } else {\r\n    sidebarWrapper.removeClass('is-sticky');\r\n  }\r\n}\r\n\r\nfunction relatedPostsCarousel() {\r\n  var $relatedBlogCarousel = jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-related-blog-carousel');\r\n  var relatedBlogCarouselSettings = {\r\n    infinite: false,\r\n    speed: 500,\r\n    slidesToShow: 1.25,\r\n    slidesToScroll: 1,\r\n    arrows: true,\r\n    dots: false\r\n  }\r\n\r\n  // slick/unslick on window width \r\n  if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).width() < 768 && $relatedBlogCarousel.length ) {\r\n    if(!$relatedBlogCarousel.hasClass('slick-initialized')) {\r\n      $relatedBlogCarousel.slick(relatedBlogCarouselSettings);\r\n    } \r\n  } else {\r\n    if($relatedBlogCarousel.hasClass('slick-initialized')) {\r\n      $relatedBlogCarousel.slick(\"unslick\");\r\n    }\r\n  }\r\n  \r\n}\n\n//# sourceURL=webpack://starter-theme/./src/scripts/templates/article.js?");

/***/ }),

/***/ "./src/styles/templates/article.scss":
/*!*******************************************!*\
  !*** ./src/styles/templates/article.scss ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://starter-theme/./src/styles/templates/article.scss?");

/***/ }),

/***/ "jquery":
/*!*************************!*\
  !*** external "jQuery" ***!
  \*************************/
/***/ ((module) => {

module.exports = jQuery;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"template.article": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = globalThis["webpackChunkstarter_theme"] = globalThis["webpackChunkstarter_theme"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor"], () => (__webpack_require__("./src/scripts/templates/article.js")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;